import { z } from 'zod';

// Alerts when the game is closed (web push). The browser makes a subscription with the server's public key
// and hands it over; the server sends to it when a message arrives and the player is not in the game.
export const PushKeyReply = z.object({ publicKey: z.string().nullable() });
export type PushKeyReply = z.infer<typeof PushKeyReply>;
export const PushSubscribe = z
  .object({
    endpoint: z.string().url().max(1000).startsWith('https://'),
    keys: z.object({ p256dh: z.string().min(10).max(200), auth: z.string().min(8).max(100) }).strict(),
  })
  .strict();
export type PushSubscribe = z.infer<typeof PushSubscribe>;
export const PushUnsubscribe = z.object({ endpoint: z.string().url().max(1000) }).strict();
export type PushUnsubscribe = z.infer<typeof PushUnsubscribe>;
// what a phone shows (and where tapping it goes)
export const PushPayload = z.object({
  title: z.string(),
  body: z.string(),
  // the game opens this chat
  url: z.string(),
  tag: z.string(),
});
export type PushPayload = z.infer<typeof PushPayload>;
